import ServiceLocator from "../ServiceLocator";
import * as PIXI from "pixi.js";

import Card from "./game/Card";
import { Signal } from "signals";
import Input from "./Input";


export default class TouchInput extends Input
{
    private _state: state_type = null;

    private _selCardIndex: number = null;


    public constructor() { super(); }

    public init(): void
    {
        this._onCardSelected = new Signal();

        this._isEnabled = true;

        this._state = state_type.SELECTING;

        ServiceLocator.app.stage.on( "pointermove", this._onStage_PointerMove, this );
        ServiceLocator.app.stage.on( "pointerdown", this._onStage_PointerMove, this );
        ServiceLocator.app.stage.on( "pointerup", this._onStage_PointerUp, this );
    }

        private _onStage_PointerMove(): void
        {
            if ( !this._isEnabled ) { return; }

            if ( this._state == state_type.SELECTING )
            {
                let selCard: Card = null;
                const kCursorPos = ServiceLocator.app.renderer.plugins.interaction.eventData.data.global;
                let hit: PIXI.DisplayObject = ServiceLocator.app.renderer.plugins.interaction.hitTest( kCursorPos, this._layers.player );
                if ( hit && hit instanceof Card )
                {
                    if ( this._baseCardY === null )
                    {
                        this._baseCardY = hit.y;
                    }

                    selCard = hit;
                }

                if ( selCard != this._selCard )
                {
                    if ( this._selCard )
                    {
                        this._selCard.y = this._baseCardY;
                    }
                    if ( selCard )
                    {
                        selCard.y = this._baseCardY - 30;
                    }
                }
                this._selCard = selCard;
            }
            else if ( this._state == state_type.CONFIRMING )
            {
                const kCursorPos = ServiceLocator.app.renderer.plugins.interaction.eventData.data.global;
                let hit: PIXI.DisplayObject = ServiceLocator.app.renderer.plugins.interaction.hitTest( kCursorPos, this._layers.player );
                if ( hit != this._selCard )
                {
                    this._state = state_type.SELECTING;

                    // Unlock selected card.
                    this._selCard.parent.setChildIndex( this._selCard, this._selCardIndex );
                    //
                    this._selCard.y = this._baseCardY;
                    this._selCard = null;

                    this._onStage_PointerMove();
                }
            }
        }

        private _onStage_PointerUp(): void
        {
            if ( !this._isEnabled ) { return; }

            if ( this._state == state_type.SELECTING )
            {
                if ( this._selCard )
                {
                    // Lock selected card.
                    this._selCardIndex = this._selCard.parent.getChildIndex( this._selCard );
                    this._selCard.parent.setChildIndex( this._selCard, this._selCard.parent.children.length - 1 );

                    this._state = state_type.CONFIRMING;
                }
            }
            else
            {
                const kCursorPos = ServiceLocator.app.renderer.plugins.interaction.eventData.data.global;
                let hit: PIXI.DisplayObject = ServiceLocator.app.renderer.plugins.interaction.hitTest( kCursorPos, this._layers.player );
                if ( hit == this._selCard )
                {
                    this._onCardSelected.dispatch( this._selCard );
                }
            }
        }

    public end(): void
    {
        ServiceLocator.app.stage.off( "pointermove", this._onStage_PointerMove, this );
        ServiceLocator.app.stage.off( "pointerdown", this._onStage_PointerMove, this );
        ServiceLocator.app.stage.off( "pointerup", this._onStage_PointerUp, this );
    
        this._onCardSelected.dispose();
        this._onCardSelected = null;
    }

    public clearSelectedCard(): void
    {
        if ( this._selCard )
        {
            this._selCard.parent.setChildIndex( this._selCard, this._selCardIndex );

            this._selCard.y = this._baseCardY;
            this._selCard = null;
        }
        
        this._state = state_type.SELECTING;
    }

    public setEnabled( isEnabled: boolean ): void
    {
        this._isEnabled = isEnabled;

        if ( !isEnabled )
        {
            if ( this._selCard )
            {
                this._selCard.y = this._baseCardY;
                this._selCard = null;
            }

            this._state = state_type.SELECTING;
        }
        else
        {
            this._onStage_PointerMove();
        }
    }
}

const enum state_type
{
    SELECTING = 0,
    CONFIRMING
}